import styled from "@emotion/styled";
import { Typography } from "@mui/material";

export const FieldLabel = styled(Typography)`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.text.secondary};
  margin-bottom: 6px;
`;

/** Mimics the email's `.main-content` card so a preview looks like the real thing. */
export const EmailPreviewSurface = styled.div`
  background: #29384d;
  color: #ffffff;
  border-radius: 8px;
  padding: 16px;
  font-family: "Kumbh Sans", Arial, sans-serif;
  overflow: hidden;
  min-height: 60px;

  img {
    max-width: 100%;
  }
`;

export const DropZone = styled.label`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 18px 12px;
  border: 1px dashed ${({ $active }) => ($active ? "#F5C754" : "rgba(128, 149, 183, 0.5)")};
  background: ${({ $active }) => ($active ? "rgba(245, 199, 84, 0.08)" : "rgba(41, 56, 77, 0.35)")};
  border-radius: 8px;
  cursor: pointer;
  text-align: center;
  color: ${({ theme }) => theme.colors.text.secondary};
  font-size: 13px;
  transition: border-color 120ms, background 120ms;

  strong {
    color: ${({ theme }) => theme.colors.text.primary};
  }

  input {
    display: none;
  }
`;

export const MediaGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(132px, 1fr));
  gap: 10px;

  @media (max-width: 480px) {
    grid-template-columns: repeat(auto-fill, minmax(104px, 1fr));
  }
`;

export const MediaTile = styled.button`
  all: unset;
  box-sizing: border-box;
  display: block;
  width: 100%;
  cursor: pointer;
  border-radius: 8px;
  overflow: hidden;
  border: 2px solid ${({ $selected }) => ($selected ? "#F5C754" : "transparent")};
  background: rgba(41, 56, 77, 0.55);

  &:focus-visible {
    outline: 2px solid #f5c754;
  }

  .thumb {
    width: 100%;
    aspect-ratio: 4 / 3;
    object-fit: contain;
    display: block;
    background: #121c24;
  }

  .meta {
    padding: 6px 8px;
    font-size: 11px;
    line-height: 1.35;
    color: ${({ theme }) => theme.colors.text.secondary};
  }

  .name {
    color: ${({ theme }) => theme.colors.text.primary};
    font-size: 12px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const SettingsLayout = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 20px;
  align-items: start;

  @media (max-width: 700px) {
    grid-template-columns: minmax(0, 1fr);
  }
`;
